import React, { Component } from 'react';

import { TabControlAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, element, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, getLostProps, propagateProps } from '@philips-emr/tws-utils';

import './tab-control.scss';

const acceptedTypes = [
  ComponentType.NAVIGATION,
];

@AwesomeComponent({ type: ComponentType.NAVIGATION, api: TabControlAPI })
class TabControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: null,
      tabContentRef: null,
    };
  }

  tabContentRef = element => {
    this.setState({
      tabContentRef: element,
    });
  };

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    defaultTab: string,
    uuid: string,
  };

  static defaultProps = {
    className: '',
  };

  onTabClick = ({ value }) => {
    this.setState({
      activeTab: value,
    });
  };

  getClassName() {
    const { className } = this.props;

    return classNames({
      'c-tab-control': true,
      [className]: className,
    });
  }

  render() {
    const { activeTab, tabContentRef } = this.state;
    const { children, defaultTab, uuid } = this.props;

    const lostProps = getLostProps(TabControl.propTypes, this.props);

    const inheritedProperties = {
      ...lostProps,
      activeTab: activeTab || defaultTab,
      onClick: this.onTabClick,
      tabContentRef,
    };

    const Container = ContainerProvider.provide(this);

    return (
      <React.Fragment>
        <Container acceptedTypes={acceptedTypes} uuid={uuid} className={this.getClassName()}>
          {propagateProps(children, inheritedProperties)}
        </Container>
        <div className="c-tab-control__content" ref={this.tabContentRef}/>
      </React.Fragment>
    );
  }
}

export default TabControl;
